<!--Title Section-->
<app-title-jumbo title="Glossary" comment="Factor Investing terms used in the application are gathered in this glossary"></app-title-jumbo>

<div class="my-container">

  <section>
    <div class="container">
      <div class="offset-1 col-10">

        <!-- All deck -->
        <div *ngFor="let component of glossaryList;" class="card-deck">
          <div class="card mb-4">
            <!--Card header-->
            <div class="card-header">
              <h3 class="card-title" style="color: rgb(118,168,255)">{{component.title}}</h3>
              <p class="card-title">{{component.definition}}</p>
            </div>

            <!--Card content-->
            <div class="card-body">
              <p>{{component.explanation}}</p>

              <p class="card-text">{{component.formulaText}}</p>

              <p class="card-text"><app-mathjax [content]="component.formula" class="box"></app-mathjax></p>

              <p class="card-text"><app-mathjax [content]="component.formulaDetails" class="box"></app-mathjax></p>

            </div>
          </div>
        </div>
        <!-- Card deck -->

      </div>
    </div>
  </section>

</div>
